import { IDialogController } from "@aurelia/dialog";

export interface IDialogButton {
  label: string;
  onClick: () => void;
}

export class MtGenericDialog {
  $dialog: IDialogController;

  activate(model: { title: string; text: string; buttons: IDialogButton[] }) {
    this.title = model.title;
    this.text = model.text;
    this.buttons = model.buttons;
  }

  title: string;
  text: string;
  buttons: IDialogButton[];
}
